module.exports = __webpack_public_path__ + "static/gradient-press-acfb5119e4e5e2f5b04747e0b3fa6a34.png";